import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Stack, Typography } from '@mui/material';
import { FC, memo } from 'react';
import { ShipperEntity } from 'src/entities/shipperEntity';

type Props = {
  option: ShipperEntity;
  disabled?: boolean;
  onDelete: (shipper: ShipperEntity) => void;
}

export const ShipperOption: FC<Props> = memo(({ option, disabled = false, onDelete }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
    <Typography>{option.name}</Typography>
    <IconButton
      size="small"
      aria-label={`${option.name}を削除`}
      disabled={disabled}
      sx={{
        color: 'error.main',
        height: 24,
        width: 24,
      }}
      onMouseDown={(event) => {
        event.preventDefault();
        event.stopPropagation();
      }}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onDelete(option);
      }}
    >
      <DeleteIcon sx={{ fontSize: 16 }} />
    </IconButton>
  </Stack>
));
